/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Loading_MoreInputs */

const en_us2_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading more…`)
};

const pt_br2_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando mais…`)
};

const es_419_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando más…`)
};

const pt_pt2_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar mais…`)
};

const fr_fr2_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const de_de2_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr wird geladen…`)
};

const it_it2_exercise_loading_more = /** @type {(inputs: Exercise_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento altri…`)
};

/**
* | output |
* | --- |
* | "Loading more…" |
*
* @param {Exercise_Loading_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_loading_more = /** @type {((inputs?: Exercise_Loading_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Loading_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_loading_more(inputs)
	if (locale === "es-419") return es_419_exercise_loading_more(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_loading_more(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_loading_more(inputs)
	if (locale === "de-DE") return de_de2_exercise_loading_more(inputs)
	if (locale === "it-IT") return it_it2_exercise_loading_more(inputs)
	return en_us2_exercise_loading_more(inputs)
});
export { exercise_loading_more as "exercise.loading_more" }